import { z } from 'zod';

import { INVOICE_OWNER_COMPANY_SUGGESTIONS_LIMIT } from './constants';

export const zodInvoiceOwnerCompanySuggestionsQueryParamsSchema = z.object({
  limit: z
    .number()
    .int()
    .min(1)
    .max(INVOICE_OWNER_COMPANY_SUGGESTIONS_LIMIT)
    .optional(),
  searchString: z.string().trim().optional(),
});

const zodInvoiceOwnerCompanySuggestionSchema = z.object({
  companyId: z.uuid(),
  name: z.string().nullable(),
});

export const zodInvoiceOwnerCompanySuggestionsResponseSchema = z.object({
  data: z.array(zodInvoiceOwnerCompanySuggestionSchema),
});
